import { Box, Typography, useTheme } from "@material-ui/core";
import { assetIds, EVENT_TYPES, ThemedAsset } from "nemuru-components";
import React, { useEffect, useState } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import MainButton from "../../../shared/components/MainButton";
import Text from "../../../shared/components/Text";
import { MILESTONES } from "../../../shared/sharedKernel/EventCatcher/config";
import { useEventDispatcher } from "../../../../utils/hooks/useEventDispatcher";

export default function KycDocumentNumberValidation() {
  const { palette } = useTheme();
  const {
    state: {
      loan,
      caixabank,
      lastActionsReference,
      lastActionsReferenceLastChange,
      participant,
    },
    dispatch,
  } = React.useContext(ProcessContext);

  const { dispatchEvent } = useEventDispatcher();

  const [gettingLoan, setGettingLoan] = useState(false);
  const [isValid, setIsValid] = useState(undefined);

  useEffect(() => {
    if (!participant.onboardingDetails.invitation.document_number) {
      dispatch({
        type: "SET_MODULE_SKIPPED",
      });
    }
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    dispatch({
      type: "REQUEST_GET_LOAN",
      payload: loan.id,
    });
  }, []);

  useEffect(() => {
    const isActionTypeInLastActionsReference = (actionType) =>
      lastActionsReference?.some((element) => element.type === actionType);
    if (isActionTypeInLastActionsReference("REQUEST_GET_LOAN_FULFILLED")) {
      setGettingLoan(true);
    }
  }, [lastActionsReferenceLastChange]);

  useEffect(() => {
    if (gettingLoan === true) {
      const documentNumberBorrowerInvitation =
        participant.onboardingDetails.invitation.document_number;

      const documentNumberKycAutomatic =
        loan?.borrower_user_details_on_origination?.document_id
          ?.document_number;

      if (documentNumberBorrowerInvitation === undefined) {
        setIsValid(true);
      } else if (documentNumberKycAutomatic === undefined) {
        setIsValid(false);
      } else if (
        documentNumberBorrowerInvitation?.toUpperCase() !==
        documentNumberKycAutomatic?.toUpperCase()
      ) {
        setIsValid(false);
      } else if (
        documentNumberBorrowerInvitation?.toUpperCase() ===
        documentNumberKycAutomatic?.toUpperCase()
      ) {
        setIsValid(true);
      }
    }
  }, [gettingLoan]);

  useEffect(() => {
    if (isValid === true) {
      dispatch({
        type: "UPDATE_PROCESS_CONTEXT",
        payload: {
          caixabank: { ...caixabank, isDocumentNumberValid: isValid },
        },
      });
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
    }
    if (isValid === false) {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      dispatch({
        type: "UPDATE_PROCESS_CONTEXT",
        payload: {
          caixabank: { ...caixabank, isDocumentNumberValid: isValid },
        },
      });
    }
  }, [isValid]);

  const onRetry = () => {
    dispatchEvent({
      name: MILESTONES.KYC_DOCUMENT_NUMBER_VALIDATION_RETRY,
      type: EVENT_TYPES.milestoneCompleted,
    });
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: { videoIdProcessPassed: undefined },
    });
    dispatch({
      type: "RESET_FLOW",
    });
  };

  return isValid === false ? (
    <>
      <Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className="appear-anim"
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            pt={3}
            pb={1}
          >
            <ThemedAsset
              id={assetIds.ICON_FAIL}
              width={50}
              height={50}
              style={{ color: palette.error.main }}
            />
            <ThemedAsset
              id={assetIds.ICON_HAND}
              width={60}
              height={60}
              style={{ color: palette.text.neutral, marginTop: "-15px" }}
            />
          </Box>
          <Box>
            <Typography
              style={{ color: palette.text.title }}
              variant="h6"
              className="mb-2 transition-all"
            >
              <strong>
                <Text tId={"OOPS"} />
              </strong>
            </Typography>
          </Box>
          <Typography
            color="textPrimary"
            variant="body2"
            className="mb-3 transition-all mt-2"
            style={{ textAlign: "center", flex: "0.5" }}
          >
            <Text tId={"DOCUMENT_NUMBER_VALIDATION_FAIL"} />
          </Typography>
          <Box mt={2}>
            <Typography variant="body2" className={"pl-2"}>
              <Text tId="PLEASE" />
              {":"}
            </Typography>
            <Box px={1}>
              <ul>
                <li>
                  <Typography variant="body2">
                    <Text tId="RESEND_PROPOSAL" />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <Text tId="RETRY_VIDEO_ID" />
                  </Typography>
                </li>
              </ul>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box>
        <MainButton onClick={onRetry}>
          <Text tId="RETRY" />
        </MainButton>
      </Box>
    </>
  ) : (
    <></>
  );
}
